import { ShareButtonComponent } from 'components/main/share-button/share-button.component'
export default ShareButtonComponent
